<template>
  <div class="section--ideas-grid">
    <IdeasGrid></IdeasGrid>
  </div>
</template>

<script>
import IdeasGrid from "@/components/ideas/IdeasGrid";
export default {
  name: "IdeasTab",
  components: {IdeasGrid},
}
</script>

<style scoped>

</style>
